import {BenjiKIVOverlayScatterReSpinResultRunner} from "./BenjiKIVOverlayScatterReSpinResultRunner";
import {SimplePresentationRunnerController} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";

/**
 * Created by Jerker Nord on 2022-12-21.
 */

export class BenjiKIVOverlayScatterSFSReSpinResultRunner extends BenjiKIVOverlayScatterReSpinResultRunner{

    constructor() {
      super();
    }

    public start(controller:SimplePresentationRunnerController):void {
        super.start(controller);
    }

    protected skip():void {
        this._controller.setSkipCallback();
        //This will stop the overlay animations
        BenjiKIV.superFSOverlayRunner.skip();
    }
}